<div class="header">
  <div class="title">{{ dynamicDialogTitle }} {{ engagementForm.get('engagement_type').value }}</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="engagementForm" class="add-note-form">
  <ng-container *ngIf="engagementForm.get('engagement_type').value === 'Call'">
    <div class="flex flex-row items-center">
      <mat-form-field class="flex-auto gt-xs:pr-3 mt-4">
        <mat-label>Call Outcome</mat-label>
        <mat-select [formControlName]="'call_outcome_id'">
          <mat-option value="">--</mat-option>
          <mat-option *ngFor="let callOutcome of callOutcomes" [value]="callOutcome.id">
            {{ callOutcome.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-auto gt-xs:pr-3 mt-4">
        <mat-label>Type</mat-label>
        <mat-select [formControlName]="'engagement_activity_type_id'">
          <mat-option value="">--</mat-option>
          <mat-option
            *ngFor="let engagementActivityType of engagementActivityTypes"
            [value]="engagementActivityType.id"
          >
            {{ engagementActivityType.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-auto gt-xs:pr-3 mt-4">
        <mat-label>Direction</mat-label>
        <mat-select [formControlName]="'call_direction'">
          <mat-option value="">--</mat-option>
          <mat-option *ngFor="let callDirection of callDirections" [value]="callDirection">
            {{ callDirection }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-auto gt-xs:pr-3 mt-4" *ngIf="contacts && contacts?.length > 0">
        <mat-label>Contact</mat-label>
        <mat-select [formControlName]="'contact_id'">
          <mat-option value="">--</mat-option>
          <mat-option *ngFor="let contact of contacts" [value]="contact.id">
            {{ contact.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container *ngIf="engagementForm.get('engagement_type').value === 'Meeting'">
    <div class="flex flex-row items-center">
      <mat-form-field class="flex-auto gt-xs:pr-3 mt-4">
        <mat-label>Meeting Outcome</mat-label>
        <mat-select [formControlName]="'meeting_outcome_id'">
          <mat-option value="">--</mat-option>
          <mat-option *ngFor="let meetingOutcome of meetingOutcomes" [value]="meetingOutcome.id">
            {{ meetingOutcome.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-auto gt-xs:pr-3 mt-4">
        <mat-label>Type</mat-label>
        <mat-select [formControlName]="'engagement_activity_type_id'">
          <mat-option value="">--</mat-option>
          <mat-option
            *ngFor="let engagementActivityType of engagementActivityTypes"
            [value]="engagementActivityType.id"
          >
            {{ engagementActivityType.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-auto gt-xs:pr-3 mt-4" *ngIf="contacts && contacts?.length > 0">
        <mat-label>Contact</mat-label>
        <mat-select [formControlName]="'contact_id'">
          <mat-option value="">--</mat-option>
          <mat-option *ngFor="let contact of contacts" [value]="contact.id">
            {{ contact.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container *ngIf="engagementForm.get('engagement_type').value === 'Social Media'">
    <div class="flex flex-row items-center">
      <mat-form-field class="flex-auto gt-xs:pr-3 mt-4">
        <mat-label>Source</mat-label>
        <mat-select [formControlName]="'social_media_source_id'">
          <mat-option value="">--</mat-option>
          <mat-option *ngFor="let socialMediaSource of socialMediaSources" [value]="socialMediaSource.id">
            {{ socialMediaSource.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-auto gt-xs:pr-3 mt-4" *ngIf="contacts && contacts?.length > 0">
        <mat-label>Contact</mat-label>
        <mat-select [formControlName]="'contact_id'">
          <mat-option value="">--</mat-option>
          <mat-option *ngFor="let contact of contacts" [value]="contact.id">
            {{ contact.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-auto gt-xs:pr-3 mt-4">
        <mat-label>Profile</mat-label>
        <input
          matInput
          [formControlName]="'social_media_profile'"
          [placeholder]="'Add social media handled or profile url.'"
        />
      </mat-form-field>
    </div>
  </ng-container>

  <quill-editor
    [formControlName]="'body'"
    [modules]="quillModules"
    (onEditorCreated)="onEditorCreated($event)"
  ></quill-editor>

  <div class="flex flex-row">
    <div class="flex-auto gt-xs:pr-3 mt-4">
      Event Date/Time
      <date-time-picker
        [formControlName]="'event_date'"
        [dateFormat]="'MM/DD/YYYY'"
        [timeFormat]="'12'"
      ></date-time-picker>
    </div>

    <div class="flex items-center flex-auto gt-xs:pr-3 mt-8" *ngIf="contact || company">
      <mat-checkbox color="primary" formControlName="createTask"> </mat-checkbox>
      <div class="task-create-title">
        {{ 'Create a task to follow up' }}
        <p>
          Make it due in the next
          <input (blur)="resetNumberOfDaysToTask()" formControlName="numberOfDaysToTask" type="text" maxlength="3" />
          day(s)
        </p>
      </div>
    </div>

    <div class="actions mt-4">
      <div class="buttons">
        <button class="discard-button" mat-button type="button" (click)="discard()">
          <span>Cancel</span>
        </button>
        <button
          class="send-button"
          mat-flat-button
          type="submit"
          [color]="'primary'"
          [disabled]="isFormDisabled()"
          DebounceClick
          (debounceLoading)="isDebounceLoading($event)"
          (debounceClick)="sendAndClose()"
        >
          <span *ngIf="!isLoading">Save</span>
          <mat-progress-spinner *ngIf="isLoading" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
        </button>
      </div>
    </div>
  </div>
</form>
